const mandatoryFields = ['name'];

export default mandatoryFields;
